import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router-dom';

const CuisineSections = (props) => {

    //console.log(props);

    let allCSS = 'btn-primary';
    
    let selectedCUISINE = '';
    if(props.selectedSECTION!='' && props.selectedSECTION!='undefined' && props.selectedSECTION!=undefined) 
    {
        selectedCUISINE = props.selectedSECTION;
        allCSS = 'btn-outline-primary';
    }

    let currentPAGE = props.page;
    let Sections = props.sections.map((post, i)=>{
        if(currentPAGE=='HOME')
        {
            return (
                <Link to={`/listing/s/${post.id}`} key={post.id} className="btn btn-outline-primary shadowed btn-sm mr-1">{post.name}</Link>
            );
        }
        else
        {
            let cuisineCSS = 'btn-outline-primary';
            if(selectedCUISINE==post.id)
                cuisineCSS = 'btn-primary';

            return (
                <button onClick={()=>{props.handleCusineClick(post.id)}} key={post.id} type="button" key={post.id} className={`btn ${cuisineCSS} shadowed btn-sm mr-1`}>{post.name}</button>
            );
        }
    });

    return (
        <div className="section full mb-3">
            <div className="section-title"><br />Cuisines</div>
            <div className="wide-block" style={{'overflowY':'scroll', 'borderBottom': '0 none'}}>
                <div style={{'display': 'flex'}}>
                    { currentPAGE=='HOME' && <Link to='/listing' className="btn btn-outline-primary btn-sm mr-1 shadowed">All</Link>}
                    { currentPAGE!='HOME' && <button type="button" onClick={()=>{props.handleCusineClick(0)}} className={`btn ${allCSS} shadowed btn-sm mr-1`}>All</button>}
                    { currentPAGE!='HOME' && <Link to='/specialdish' className="btn btn-outline-primary btn-sm mr-1 shadowed">Speciality Dish</Link>}
                    {Sections}
                </div>
            </div>
        </div>
    );
}
  
export default CuisineSections;


// WEBPACK FOOTER //
// ./src/components/CuisineSections.js